import { registerMerchant } from './merchant'
import { registerAdmin } from './admin'
import { registerUtils } from './utils'
import { registerAntd } from '@klook/admin-cli-service'
import { registerI18n } from './i18n'
import { registerAIAssistant } from './ai-assistant'

export default async function registerPlugins(ctx) {
  const { isMerchant } = ctx

  // 注册公共插件
  await registerUtils(ctx)
  await registerI18n(ctx)

  if (isMerchant) {
    await registerMerchant(ctx)
  } else {
    await registerAdmin(ctx)
  }

  await registerAntd(ctx)

  // AI Assistant 仅 merchant 端启用：admin 后端未提供 agent/init 接口，
  // 注册会触发 POST /v1/merchantagentsrv/agent/init 返回 405
  if (isMerchant) {
    registerAIAssistant(ctx)
  }

  return ctx
}
